<template>
  <div id="line-chart">
    <div class="ipub-h2 line-h-40 mar-b-10">Zone Line Chart</div>
    <div class="ipub-block ">
      <div id="zone-line-chart"
           class="flex"
           style="width:auto;align-items: center;justify-content: center;height:500px">
      </div>
    </div>
  </div>
</template>

<script>
import { statisticJournalCountry } from '@/api/statistic'
export default {
  props: {
    params: {
      type: Object,
      default () { return {} }
    },
    issueList: {
      type: Array,
      default () { return [] }
    },
    volumeList: {
      type: Array,
      default () { return [] }
    },
    issueId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      zoneArticalNumber: [],
      lineOption: null,
      zoneX: [],
      zoneY: [],
      zoneY1: [],
      zoneY2: [],
      zoneY3: [],
      zoneYChina: [],
      colorType: ['#1E1D40', '#174A87', '#0091FF', '#FA6400'],
    }
  },
  watch: {
    issueId: {
      handler (val) {
        if (this.params && this.params.journalId && val) {
          this.getData()
        }
        // this.params.issueId = val
      },
      deep: true
    }
  },
  mounted () {
    if (this.params && this.params.journalId && this.issueId) {
      this.getData()
    }
  },
  methods: {
    async getData () {
      const data = Object.assign(this.params, {
        issueId: this.issueId
      })
      const reponse = await statisticJournalCountry.issue(data)
      this.zoneArticalNumber = reponse ? reponse : []
      this.zoneX = reponse && reponse.length > 0 && reponse.map(item => item.issueCode)
      const zone1 = [], zone2 = [], zone3 = [], zoneChina = []
      let total1 = 0, total2 = 0, total3 = 0, totalChina = 0
      for (let i = 0; i < reponse.length; i++) {
        total1 = total2 = total3 = totalChina = 0
        reponse[i].oneZoneList && reponse[i].oneZoneList.map(ele => {
          total1 += Number(ele.articleNum)
        })
        reponse[i].twoZoneList && reponse[i].twoZoneList.map(ele => {
          total2 += Number(ele.articleNum)
        })
        reponse[i].threeZoneList && reponse[i].threeZoneList.map(ele => {
          total3 += Number(ele.articleNum)
        })
        reponse[i].chinaList && reponse[i].chinaList.map(ele => {
          totalChina += Number(ele.articleNum)
        })
        zone1.push(total1)
        zone2.push(total2)
        zone3.push(total3)
        zoneChina.push(totalChina)
      }
      this.zoneY1 = zone1
      this.zoneY2 = zone2
      this.zoneY3 = zone3
      this.zoneYChina = zoneChina
      this.optionType()
    },
    getEchart () {
      var echarts = require('echarts')
      let myChart = echarts.init(document.getElementById('zone-line-chart'))
      myChart.setOption(this.lineOption)
    },
    optionType () {
      this.lineOption = {
        tooltip: {
          // trigger: 'axis',
          trigger: 'item',
          enterable: true,
          position: 'right',
          formatter: (params) => {
            let item = {}
            let res = `<div class="ipub-p1 line-h-40">Vol ${this.volumeList.find(item => item.id === this.params.volumeId).code}, Issue ${params.name}</div><div class="ipub-p1 mar-b-20">${params.seriesName}</div>`
            res += `<div class="ipub-p2">Total: ${params.value}</div>`
            for (let i = 0; i < this.zoneArticalNumber.length; i++) {
              if (this.zoneArticalNumber[i].issueCode === params.name) {
                item = this.zoneArticalNumber[i]
              }
            }
            if (params.seriesName === 'Zone I') {
              item.oneZoneList && item.oneZoneList.map(ele => {
                res += `<div class="ipub-p2">${ele.name}: ${ele.articleNum}</div>`
              })
            }
            if (params.seriesName === 'Zone II') {
              item.twoZoneList && item.twoZoneList.map(ele => {
                res += `<div class="ipub-p2">${ele.name}: ${ele.articleNum}</div>`
              })
            }
            if (params.seriesName === 'Zone III') {
              item.threeZoneList && item.threeZoneList.map(ele => {
                res += `<div class="ipub-p2">${ele.name}: ${ele.articleNum}</div>`
              })
            }
            if (params.seriesName === 'China') {
              item.chinaList && item.chinaList.map(ele => {
                res += `<div class="ipub-p2">${ele.name}: ${ele.articleNum}</div>`
              })
            }
            // console.log(res, 'ress')
            // let res = `<span>${params.name}</span> <span  style="margin: 6px">|</span> <span>${params.percent}%</span> <span  style="margin-left:16px">${params.value}</span>`
            return res
          },
          extraCssText: 'background: #fff; border-radius: 50;color: #1E1D40;border:none;font-size:12px;overflow: scroll;overflow-x:hidden;max-height:300px'
        },
        legend: {
          data: ['Zone I', 'Zone II', 'Zone III', 'China'],
          bottom: '0',
          left: '60',
          icon: 'circle',
          itemWidth: 20,
          itemHeight: 20,
          itemGap: 40,
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.zoneX,
          axisLine: {
            show: true,
            lineStyle: {
              color: '#1E1D40',
              width: 2
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: true,
            lineStyle: {
              color: '#1E1D40',
              width: 2
            }
          }
        },
        dataset: {
          // source: [
          //   this.zoneX,
          //   ['Zone I', ...this.zoneY1],
          //   ['Zone II', ...this.zoneY2],
          //   ['Zone III', ...this.zoneY3],
          //   ['China', ...this.zoneYChina],
          // ]
        },
        series: [
          {
            name: 'Zone I',
            type: 'line',
            smooth: true,
            data: this.zoneY1,
            color: this.colorType[0],
            showSymbol: true,
            symbol: 'circle',     //设定为实心点
            symbolSize: 10,
            // markPoint: {     //显示一定区域内的最大值和最小值
            //   data: [
            //     { type: 'max', name: '10' },
            //     { type: 'min', name: '5' }
            //   ]
            // }
          },
          {
            name: 'Zone II',
            type: 'line',
            smooth: true,
            data: this.zoneY2,
            color: this.colorType[1],
            symbol: 'circle',     //设定为实心点
            symbolSize: 10,
          },
          {
            name: 'Zone III',
            type: 'line',
            smooth: true,
            data: this.zoneY3,
            color: this.colorType[2],
            symbol: 'circle',     //设定为实心点
            symbolSize: 10,
          },
          {
            name: 'China',
            type: 'line',
            smooth: true,
            data: this.zoneYChina,
            color: this.colorType[3],
            symbol: 'circle',     //设定为实心点
            symbolSize: 10,
          }
        ]
      }
      this.getEchart()
    },
  }
}
</script>

<style lang="scss" scoped>
@import './main.scss';
#line-chart {
  width: 100%;
}
</style>
